import React from "react";
import { Linkedin } from "lucide-react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function Team() {
  const { t } = useLang();
  const c = t.team;
  return (
    <section id="equipo" data-testid="team-section" className="py-24 sm:py-32 border-t border-border">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section text-olive">
            {c.title}
          </Reveal>
          <Reveal className="col-span-12 lg:col-span-8 lg:col-start-4">
            <p className="text-lg text-olive-soft leading-relaxed">{c.intro}</p>
          </Reveal>
        </div>

        <Reveal className="grid grid-cols-12 gap-x-6 gap-y-8 border-t border-border pt-12">
          <div className="col-span-12 lg:col-span-4">
            <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta mb-3">{c.role}</div>
            <div className="font-display text-5xl sm:text-6xl text-olive leading-[1.02]">{c.name}</div>
          </div>
          <div className="col-span-12 lg:col-span-7 lg:col-start-6">
            <p className="text-lg text-olive-soft leading-relaxed mb-6">{c.bio}</p>
            <a
              href={c.linkedinUrl || "https://www.linkedin.com/in/"}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="team-linkedin"
              className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.3em] uppercase text-olive link-underline"
            >
              <Linkedin size={16} strokeWidth={1.5} aria-hidden />
              {c.linkedin}
            </a>
          </div>
        </Reveal>

        {c.incoming && (
          <Reveal className="mt-20 grid grid-cols-12 gap-x-6 gap-y-8">
            <div className="col-span-12 lg:col-span-4">
              <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta mb-3">{c.incomingTitle}</div>
              <p className="text-olive-soft text-sm font-serif italic leading-relaxed max-w-xs">{c.incomingNote}</p>
            </div>
            <div className="col-span-12 lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-px bg-border border-t border-l border-border">
              {c.incoming.map((hire, i) => (
                <div key={i} data-testid={`incoming-hire-${i}`} className="bg-ivory p-6 border-r border-b border-border">
                  <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-olive-soft mb-2">{hire.tag}</div>
                  <div className="font-display text-2xl text-olive leading-tight">{hire.role}</div>
                </div>
              ))}
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
